const animations = {
    name: "Animations",
    items: ["travelingVideo", "lalisaAnimation", "smokingAnimation", "animationIncrustation", "outOfBoxPoster", "oceatikaAnim"],
    coverImage: "tileAnimation",
    tile: "contain",
    colorTheme: "#fe4406",
}

export const collectionsMap = {
    animations,
    albumCovers: {
        name: "Miserecord",
        coverImage: "coverAlbum2",
        banner: "REIMAGINE ALBUM COVERS - Creation of album artworks",
        description: "desc_albumCovers"
    },
    miserecordPart2: {
        name: "Miserecord - Part 2",
        coverImage: "miserecordTrifold2",
        colorTheme: "#dd95bc"
    },
    ginProject: {
        name: "Gin Bottle",
        coverImage: "ginProject3",
        banner: "DR JAKE HILL - product branding",
        tile: "contain"
    },
    mix_media: {
        name:"Simplification",
        coverImage: "mixMedia3",
        banner: "SIMPLIFICATION OF ONE PICTURE",
    },
    linocutSports: {
        name: "Linocut of Sports",
        coverImage: "sportsLino",
        banner:"LINOCUT OF SPORTS",
        colorTheme: "#ebebeb",
        tile: "contain"
    },
    baristaCoffee: {
        name: "Barista Coffee",
        fullname: "Barista the good taste for all! ",
        colorTheme: "#FFFFFF",
        backgroundImage: "patternCoffee",
        coverImage: "baristaEthiopia",
        banner: "Barista the good taste for all!",
        background: "cover"
    },
    limbo: {
        name: "Limbo",
        coverImage: "limboAnimation",
        colorTheme: "#555656",
    },
    restProject: {
        name: "REST",
        fullname: "REST - Renewable Streetwear",
        coverImage: "restMockup",
        colorTheme: "#e7d8b7"
    },
    traveling: {
        name: "Traveling",
        coverImage: "travelingVideo",
        colorTheme: "#fbbe28",
    },
    turbulences: {
        name: "Turbulences Festival",
        coverImage: "mockupEvent2",
        banner:"Conception of an event identity",
        backgroundImage: "mockupPosterEvent2",
        background: "cover",
        colorTheme: "#5e2e04aa"
    },
    turbulencesOob: {
        name: "Turbulences Festival - Out of the box",
        coverImage: "outOfBox2",
        background: "cover",
        colorTheme: "#5c7a5e",
        description: "desc_outOfBox"
    },
    oceatika: {
        name: "OCEATIKA",
        coverImage: "backAndFront",
        background: "cover",
        banner:"/CONNECTIVITY // FUTURISTIC // PLAYFUL // EDUCATIVE/",
        coverColor: "#6e94b7",
        colorTheme: "#dfa785",
        coverSize: "contain",
        description: "desc_oceatika"
    },
    theDock: {
        name: "The Dock",
        coverImage: "dulsePastaFront",
        background: "cover",
        colorTheme: "#54a8ac",
        description: "desc_theDock"
    },
    seasPiracy: {
        name: "SEASPIRACY",
        coverImage: "seasPiracyPoster2",
        background: "cover",
        colorTheme: "#755555"
    },
    hafgufa: {
        name: "Hafgufa",
        coverImage: "hafgufa1",
    },
    seh: {
        name: "Sama Ethica Humanis",
        coverImage: "mockupSehPosters",
        banner:"Conception of an identity",
        background: "cover",
        colorTheme: "#54a8ac"
    },
}